"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationSubjectType = void 0;
var NotificationSubjectType;
(function (NotificationSubjectType) {
    NotificationSubjectType[NotificationSubjectType["Order"] = 0] = "Order";
    NotificationSubjectType[NotificationSubjectType["Customer"] = 1] = "Customer";
    NotificationSubjectType[NotificationSubjectType["Driver"] = 2] = "Driver";
    NotificationSubjectType[NotificationSubjectType["DriversCompany"] = 3] = "DriversCompany";
    NotificationSubjectType[NotificationSubjectType["Route"] = 4] = "Route";
    NotificationSubjectType[NotificationSubjectType["Location"] = 5] = "Location";
    NotificationSubjectType[NotificationSubjectType["Exports"] = 6] = "Exports";
})(NotificationSubjectType || (exports.NotificationSubjectType = NotificationSubjectType = {}));
//# sourceMappingURL=NotificationSubjectType.js.map